var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('div',{staticClass:"link"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }